/**
 * Prepare stored email HTML for the in-app editor / live preview.
 * Prebuilt templates often include a full document shell and pretty-print
 * whitespace that shows as large empty gaps when rendered with pre-wrap.
 */
export const normalizeEmailHtmlForEditor = (html) => {
    if (!html) return "";

    let cleaned = String(html);

    const bodyMatch = cleaned.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    if (bodyMatch) {
        cleaned = bodyMatch[1];
    }

    cleaned = cleaned.replace(/<\/?(?:html|head|meta|title|!doctype)[^>]*>/gi, "");

    // Collapse inter-tag whitespace that otherwise becomes visible vertical gaps.
    cleaned = cleaned.replace(/>\s+</g, "><");

    const stripEmptyEdges = (value) => {
        let next = value;
        let previous = null;

        while (next !== previous) {
            previous = next;
            next = next
                .replace(/^(?:\s|&nbsp;)+/i, "")
                .replace(/^(?:<(?:br|hr)\b[^>]*\/?\s*>)+/i, "")
                .replace(
                    /^<(p|div|span|font)(?:\s[^>]*)?>\s*(?:&nbsp;|\s|<br\s*\/?\s*>)*\s*<\/\1>/i,
                    ""
                )
                .replace(/(?:\s|&nbsp;)+$/i, "")
                .replace(/(?:<(?:br|hr)\b[^>]*\/?\s*>)+$/i, "")
                .replace(
                    /<(p|div|span|font)(?:\s[^>]*)?>\s*(?:&nbsp;|\s|<br\s*\/?\s*>)*\s*<\/\1>$/i,
                    ""
                );
        }

        return next;
    };

    cleaned = stripEmptyEdges(cleaned);

    // Collapse long runs of empty spacer paragraphs / breaks inside the body.
    cleaned = cleaned.replace(
        /(?:<(?:p|div)(?:\s[^>]*)?>\s*(?:&nbsp;|\s|<br\s*\/?\s*>)*\s*<\/(?:p|div)>\s*){2,}/gi,
        ""
    );
    cleaned = cleaned.replace(/(?:<br\s*\/?\s*>\s*){3,}/gi, "<br><br>");

    return cleaned.trim();
};
